import React from 'react'
import ATLoaderContainer from '../../../common/loaderContainer/ATLoaderContainer'
import ATModuleMessage from '../../../common/message/ATModuleMessage'
import ATLoader from '../../../common/loader/ATLoader'
import {
  CapabilityItem,
  CapabilityListProps,
} from '../../../../utils/types/roles/RolesTypes'
import { Form } from 'react-bootstrap'

const CapabilityList = <T extends CapabilityItem>({
  options,
  isFeatureChecked,
  handleSelection,
  activeFeature,
  setActiveFeature,
  disabled,
  level,
  featureNameKey,
  featureCodeKey,
  isLoading,
}: CapabilityListProps<T>) => {
  const getJSX = () => {
    if (isLoading) {
      return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <ATLoaderContainer>
            <ATLoader />
          </ATLoaderContainer>
        </div>
      )
    } else if (options?.length > 0) {
      return (
        <div className="capability-list-container">
          <div className="d-flex justify-content-center align-items-center capability-checkbox-item">
            <p className="mb-2">{`Level ${level}`}</p>
          </div>
          {options?.map((item, index) => (
            <div
              className={`${
                activeFeature === item[featureCodeKey] ? 'active-feature' : ''
              } d-flex justify-content-start align-items-center py-2 job-checkbox-item list-hauler-style col-md-12 col-12`}
              key={index}
            >
              <div className="d-flex justify-content-center align-items-center">
                <Form.Check
                  type="checkbox"
                  id={JSON.stringify(item)}
                  checked={isFeatureChecked(item[featureCodeKey] ?? '')}
                  onChange={(e) =>
                    handleSelection(e, item[featureCodeKey] ?? '')
                  }
                  disabled={!disabled}
                  className="invoice_select_group"
                />
              </div>
              <p
                className="ps-2 pointer flex-1 user-select-none m-0"
                onClick={(e) => {
                  e.stopPropagation()
                  if (level !== 3) {
                    setActiveFeature?.(item[featureCodeKey] ?? '')
                  }
                }}
              >
                {item[featureNameKey] ?? ''}
              </p>
            </div>
          ))}
        </div>
      )
    } else {
      return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <ATLoaderContainer>
            <ATModuleMessage />
          </ATLoaderContainer>
        </div>
      )
    }
  }

  return (
    <div className="jobs-checkbox-wrapper h-100 checkbox-row-gap w-100 px-1">
      {getJSX()}
    </div>
  )
}

export default React.memo(CapabilityList)
